<template>
    <div class="login-wrap">
        <div class="ms-title">{{page_data.title}}</div>
        <!--登录-->
        <div class="ms-login" >
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm"
                     v-loading="loadFlag"
                     :element-loading-text="page_data.loadTxt">
                <!--帐号-->
                <el-form-item prop="username">
                    <el-input v-model="ruleForm.username" :placeholder="page_data.account"  size="large"></el-input>
                </el-form-item>
                <!--密码-->
                <el-form-item prop="password">
                    <el-input type="password" :placeholder="page_data.pwd" v-model="ruleForm.password" @keyup.enter.native="submitForm('ruleForm')"  size="large"></el-input>
                </el-form-item>
                <!--登录按钮-->
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm('ruleForm')">{{page_data.login}}</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {Login} from '../stores/api'
    export default {
        data: function() {
//            登录验证
            var validateUsername = function(rule, value, callback) {
                if (value === "") {
                    callback(new Error('帐号不能为空'))
                } else {
                    callback()
                }
            }
            var validateUserpwd = function(rule, value, callback) {
                if (value === "") {
                    callback(new Error('密码不能为空'))
                } else {
                    callback()
                }
            }
            return {
                page_data: {
                    title: "亿星2.0售后系统",
                    account: "请输入帐号",
                    pwd: "请输入密码",
                    login: "登 录",
                    loadTxt: "登录中"
                },
                loadFlag:false,
                ruleForm: {
                    username: '',
                    password: ''
                },
                rules: {
                    username: [
                        { validator: validateUsername, trigger: 'blur'}
                    ],
                    password: [
                        { validator: validateUserpwd, trigger: 'blur'}
                    ]
                },
            }
        },
        methods: {
//            登录
            submitForm(formName) {
                const self = this;
//            self.loadFlag=true;
                self.$refs[formName].validate((valid) => {
                    if (valid) {
                       Login(self.ruleForm.username, self.ruleForm.password).then(res => {
                           // console.log(res.data)
                           if (0 === res.data.error) {
                               this.$message.success('登录成功,欢迎' + res.data.user_name)
                               localStorage.setItem('shouhou_session_id', res.data.session_id)
                               localStorage.setItem('user_name', res.data.user_name)
                               localStorage.setItem('role_id', res.data.role_id)
                               localStorage.setItem('role', res.data.role)
                               if (res.data.role_id === '8') {
                                   this.$router.push({path: 'Cangku'})
                               } else{
                                   this.$router.push({path: 'DeFuil'})
                               }
                           }
                       }).catch(() => {
                           this.$message.error('帐号或密码错误')
                       })
                    } else {
                        self.loadFlag = false;
                        self.$message.error('请输入正确的帐号和密码')
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped lang="less">
    /*登录*/
    .login-wrap {
        position: relative;
        width:100%;
        height:100%;
        background: #CC95C0;  /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #7AA1D2, #DBD4B4, #CC95C0);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #d29a60, #dbd4b4, #a1d2db, #7096cc); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        /*标题*/
        .ms-title {
            position: absolute;
            top:50%;
            width:100%;
            margin-top: -230px;
            text-align: center;
            font-size:30px;
            color: #cd6934;
        }
        /*登录框*/
        .ms-login {
            position: absolute;
            left:50%;
            top:50%;
            width:300px;
            height:180px;
            margin:-150px 0 0 -190px;
            padding:40px;
            border-radius: 5px;
            background: rgba(253, 248, 255, 0.2);
            /*按钮*/
            .login-btn {
                text-align: center;
                button{
                    width:100%;
                    background: #dc886f;  /* fallback for old browsers */
                    background: -webkit-linear-gradient(to right, #B06AB3, #4568DC);  /* Chrome 10-25, Safari 5.1-6 */
                    background: linear-gradient(to right, #dc7e47); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
                    border: none;
                    /*height:45px;*/
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/router/Login.vue